import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/siteData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-20 md:py-28">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <Reveal>
          <SectionHeading kicker="FAQ" title="자주 묻는 질문" />
        </Reveal>

        <div className="mt-12 divide-y divide-background-200/70 border-y border-background-200/70">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-4">
                    <span className="font-label mt-0.5 text-sm text-primary-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span
                      className={`text-sm font-medium transition-colors duration-300 md:text-base ${
                        isOpen ? "text-primary-400" : "text-foreground-900"
                      }`}
                    >
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                    }`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="pb-5 pl-9 pr-7 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}